export interface Number {
  isEven: boolean;
  isOdd: boolean;
}

// eslint-disable-next-line no-extend-native
Object.defineProperties(Number.prototype, {
  isEven: {
    get() {
      return this % 2 === 0;
    },
  },
  isOdd: {
    get() {
      return this % 2 !== 0;
    },
  },
});
